module.exports = __webpack_public_path__ + "img/Facebook.0350ffea.png";